import React from "react";

const TrophyGradient = () => (
  <svg
    role="img"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="365.927"
    height="8.029"
    viewBox="0 0 365.927 8.029"
    aria-label="trophy gradient">
    <defs>
      <linearGradient
        id="fys16uc9va"
        x1=".88"
        x2="-.095"
        y1=".5"
        y2="1"
        gradientUnits="objectBoundingBox">
        <stop offset="0" stopColor="#213870" />
        <stop offset="1" stopColor="#fcd408" />
      </linearGradient>
    </defs>
    <path
      fill="url(#fys16uc9va)"
      d="M-765.675-.077l336.389.01c5.506.205 11.842 3.442 14.951 8.02h-365.927a17.138 17.138 0 0 1 14.587-8.03z"
      transform="translate(780.262 0.077)"
    />
  </svg>
);

export default TrophyGradient;
